import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class AddressService extends BaseService {
  private url = "api/address";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

  /**
   * 获取登入供应商简单信息
   */
  getSupplierInfo():Observable<any> {
    const url = "api/supplier/current-sample";
    return this.http.get<any>(url).pipe(
      tap(_ => this.log("getSupplierSimple")),
      catchError(this.handleError<any>("getSupplierSimple"))
    );
  }

  /** 根据编码查询国家 */
  getCountryByCode(countryCode:string):Observable<any> {
    const url = `${this.getUrl()+"/country"}/${countryCode}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${countryCode}`)),
      catchError(this.handleError<any>(`getany code=${countryCode}`))
    );
  }

  /** 根据编码查询地区/省份 */
  getProvinceByCode(code:string):Observable<any> {
    const url = `${this.getUrl()+"/region"}/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${code}`)),
      catchError(this.handleError<any>(`getany code=${code}`))
    );
  }

  /** 根据编码查询城市 */
  getCityByCode(code:string):Observable<any> {
    const url = `${this.getUrl()+"/city"}/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${code}`)),
      catchError(this.handleError<any>(`getany code=${code}`))
    );
  }

  /** 查询全部国家 */
  getAllCountry():Observable<any> {
    const url = `${this.getUrl()}/country`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`get all country`)),
      catchError(this.handleError<any>(`get all country`))
    );
  }

  /** 根据id查询地区/省份 */
  getProvinceById(id:number):Observable<any> {
    const url = `${this.getUrl()+"/regionById"}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }

  /** 根据id查询地区/省份 */
  getCityById(id:number):Observable<any> {
    const url = `${this.getUrl()+"/cityById"}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }

  /** 根据国家code查询地区/省份 */
  getProvinceByCountryCode(code:string):Observable<any> {
    const url = `${this.getUrl()+"/regionByCode"}/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${code}`)),
      catchError(this.handleError<any>(`getany id=${code}`))
    );
  }

  /** 根据省份code查询地区/省份 */
  getCityByProvinceCode(code:string):Observable<any> {
    const url = `${this.getUrl()+"/cityByCode"}/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${code}`)),
      catchError(this.handleError<any>(`getany id=${code}`))
    );
  }
}
